var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrderSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "c97bb219-a7b0-41d5-b577-f3a849972cf0"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "2dcac15c-0960-4e35-b600-3079ee341fa5"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(67.5 0 0 67.5 540 540)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(3,166,133)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-7.6, -7.97)",
    d: "M 7.59 0 L 8.785 1.72 L 10.505 0.6159999999999999 L 10.97 2.676 L 12.975000000000001 2.3360000000000003 L 12.650000000000002 4.439 L 14.614000000000003 4.927 L 13.561000000000003 6.731999999999999 L 15.2 7.985 L 13.559999999999999 9.238 L 14.613 11.044 L 12.649 11.532 L 12.973999999999998 13.634 L 10.968999999999998 13.294 L 10.503999999999998 15.354000000000001 L 8.783999999999997 14.25 L 7.589999999999997 15.95 L 6.395999999999997 14.229999999999999 L 4.674999999999997 15.332999999999998 L 4.208999999999997 13.294999999999998 L 2.205999999999997 13.634999999999998 L 2.528999999999997 11.531999999999998 L 0.5659999999999967 11.043999999999999 L 1.6179999999999968 9.238 L 0 7.985 L 1.64 6.732 L 0.566 4.927 L 2.53 4.44 L 2.207 2.3380000000000005 L 4.21 2.6770000000000005 L 4.676 0.6170000000000004 L 6.396 1.7210000000000005 L 7.591 0 z M 9.358 6.12 L 6.687 9.007 C 6.678464402774925 9.016516888300645 6.666283879806838 9.021954201624853 6.6535 9.021954201624853 C 6.640716120193162 9.021954201624853 6.628535597225075 9.016516888300645 6.62 9.007 L 5.64 7.955 C 5.572147195333747 7.8802986965051085 5.475917232645928 7.837705213902815 5.375 7.837705213902815 C 5.27408276735407 7.837705213902815 5.177852804666252 7.8802986965051085 5.109999999999999 7.955 C 4.963585155981024 8.11449294341875 4.963585155981024 8.35950705658125 5.109999999999999 8.519 L 6.392999999999999 9.889 C 6.462999999999999 9.963999999999999 6.557999999999999 10.001 6.657999999999999 10.001 L 6.659999999999998 10.001 C 6.759999999999998 10.001 6.854999999999999 9.962 6.924999999999998 9.886 L 9.894999999999998 6.677999999999999 C 10.03883796893021 6.516846081642806 10.035800264646971 6.272527865719466 9.887999999999998 6.114999999999999 C 9.819326745497055 6.041393572390953 9.722836637250897 6.000101678589804 9.622175728433506 6.001243390221003 C 9.521514819616115 6.0023851018522025 9.425986091653595 6.045854903058364 9.358999999999998 6.1209999999999996 z",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderSuccess);
export default __webpack_public_path__ + "static/media/orderSuccess.5ed3d0179ce9b6f5901b8fbcd92ce195.svg";
export { ForwardRef as ReactComponent };